import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getValueFromPath = (path: string): number => {
    switch (path) {
      case '/dashboard':
      case '/home':
        return 0;
      case '/quests':
        return 1;
      case '/leagues':
        return 2;
      case '/feed':
        return 3;
      case '/profile':
        return 4;
      default:
        return 0;
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        navigate('/dashboard');
        break;
      case 1:
        navigate('/quests');
        break;
      case 2:
        navigate('/leagues');
        break;
      case 3:
        navigate('/feed');
        break;
      case 4:
        navigate('/profile');
        break;
    }
  };

  // Don't show on onboarding or auth pages
  if (['/onboarding', '/login', '/register', '/'].includes(location.pathname)) {
    return null;
  }

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        borderTop: '1px solid',
        borderColor: 'divider',
        zIndex: 1200
      }} 
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={getValueFromPath(location.pathname)}
        onChange={handleChange}
      >
        <BottomNavigationAction 
          label="Home" 
          icon={<HomeIcon />}
          sx={{ minWidth: 60 }}
        />
        <BottomNavigationAction 
          label="Quests" 
          icon={
            <span style={{ fontSize: '24px' }}>💎</span>
          }
          sx={{ minWidth: 60 }}
        />
        <BottomNavigationAction 
          label="Leagues" 
          icon={<EmojiEventsIcon />}
          sx={{ minWidth: 60 }}
        />
        <BottomNavigationAction 
          label="Feed" 
          icon={<MoreHorizIcon />}
          sx={{ minWidth: 60 }}
        />
        <BottomNavigationAction 
          label="Profile" 
          icon={<PersonIcon />}
          sx={{ minWidth: 60 }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;